import "./fullPageLoader.scss";

const FullPageLoader = () => {
  return (
    <div data-testid="full-page-loader" className="fp_loading">
      <img
        alt="MiM"
        src={process.env.PUBLIC_URL + "/images/mim-logo.png"}
        className="h-[68px]"
      ></img>
      <div className="loader mt-3"></div>
    </div>
  );
};

export default FullPageLoader;
